/* OPTION C HEADER (Oct 13, Vlad's board, jarvis 22223): the Welcome back pill with the pieces viewed (localStorage
   trax_rv, written on product pages: {handle,title,img,price,url}), and TRENDING as six chips with the rest under
   "More trends" (the board says Top 50 Trends). Loaded only with Theme settings > Header > Option C header ticked. */
(function () {
  if (!window.matchMedia || !matchMedia('(min-width:1100px)').matches) return; // phones keep today's header
  var H = document.querySelector('header.site'); if (!H) return;
  var wrap = H.querySelector('.hdr .wrap'), hot = H.querySelector('.hot'); if (!wrap || !hot) return;
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  function closeAll(except) { [].forEach.call(H.querySelectorAll('[data-oc-menu]'), function (m) { if (m !== except) { m.hidden = true; var b = document.getElementById(m.getAttribute('aria-labelledby')); if (b) b.setAttribute('aria-expanded', 'false'); } }); }
  function toggle(btn, menu) { btn.addEventListener('click', function (e) { e.stopPropagation(); var open = menu.hidden; closeAll(menu); menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }); }
  document.addEventListener('click', function (e) { if (!H.contains(e.target) || !e.target.closest('[data-oc-menu],.oc-wb-b,.oc-more-b')) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Welcome back */
  try {
    var rv = JSON.parse(localStorage.getItem('trax_rv') || '[]');
    if (rv.length >= 2) {
      var here = location.pathname.replace(/\/$/, '');
      var box = document.createElement('div'); box.className = 'oc-wbc';
      var b = document.createElement('button'); b.type = 'button'; b.className = 'oc-wb-b'; b.id = 'oc-wb-b'; b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-haspopup', 'true');
      var th = document.createElement('span'); th.className = 'oc-wb-th';
      rv.slice(0, 3).forEach(function (it) { if (!it.img) return; var im = document.createElement('img'); im.alt = ''; im.loading = 'lazy'; im.src = it.img; th.appendChild(im); });
      var t = document.createElement('span'); t.className = 'oc-wb-t'; t.innerHTML = '<b>Welcome back</b><small></small>';
      t.querySelector('small').textContent = Math.min(rv.length, 3) + ' pieces you viewed';
      b.appendChild(th); b.appendChild(t); b.insertAdjacentHTML('beforeend', CHEV);
      var m = document.createElement('div'); m.className = 'oc-wb-m'; m.hidden = true; m.setAttribute('data-oc-menu', ''); m.setAttribute('aria-labelledby', 'oc-wb-b');
      m.innerHTML = '<b>PICK UP WHERE YOU LEFT OFF</b>';
      rv.slice(0, 3).forEach(function (it) {
        var a = document.createElement('a'); a.className = 'oc-wb-i'; a.href = it.url || ('/products/' + it.handle);
        var on = (it.url || '').split('?')[0].replace(/\/$/, '') === here;
        a.innerHTML = '<img alt="" loading="lazy"><span><b></b></span><em></em>';
        if (it.img) a.querySelector('img').src = it.img; else a.querySelector('img').remove();
        a.querySelector('b').textContent = it.title || '';
        if (it.price) a.querySelector('span').appendChild(document.createTextNode(String(it.price)));
        var em = a.querySelector('em'); em.textContent = on ? 'Viewing' : 'Viewed'; if (on) em.className = 'on';
        m.appendChild(a);
      });
      box.appendChild(b); box.appendChild(m);
      var search = wrap.querySelector('.search'); wrap.insertBefore(box, search || hot);
      toggle(b, m);
    }
  } catch (e) {}

  /* TRENDING: six chips in two rows, the rest under Top 50 Trends */
  try {
    var chips = [].filter.call(hot.querySelectorAll('a'), function (a) { return !a.classList.contains('wb'); });
    if (chips.length) {
      var row = document.createElement('div'); row.className = 'oc-chips';
      chips.slice(0, 6).forEach(function (a) { row.appendChild(a); });
      hot.appendChild(row);
      var rest = chips.slice(6);
      var more = document.createElement('div'); more.className = 'oc-more';
      var mb = document.createElement('button'); mb.type = 'button'; mb.className = 'oc-more-b'; mb.id = 'oc-more-b'; mb.setAttribute('aria-expanded', 'false'); mb.innerHTML = 'More trends ' + CHEV; // the board reads Top 50 Trends; the store has ten trending searches, so it says More
      var mm = document.createElement('div'); mm.className = 'oc-more-m'; mm.hidden = true; mm.setAttribute('data-oc-menu', ''); mm.setAttribute('aria-labelledby', 'oc-more-b');
      rest.forEach(function (a) { mm.appendChild(a); });
      if (rest.length) { more.appendChild(mb); more.appendChild(mm); row.appendChild(more); }
      toggle(mb, mm);
    }
  } catch (e) {}
})();
